import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-collapsible',
  imports: [CommonModule],
  templateUrl: './collapsible.component.html',
  styleUrl: './collapsible.component.scss'
})
export class CollapsibleComponent {
  @Input() title = '';
  @Input() isExpanded = true;

  toggle(): void {
    this.isExpanded = !this.isExpanded;
  }
}
